import React, { useState, useEffect } from 'react'
import './ScrollToTop.css'

export default function ScrollToTop() {
  const [isVisible, setIsVisible] = useState(false)

  // Show button when page is scrolled down
  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true)
    } else {
      setIsVisible(false)
    }
  }

  // Scroll to top smoothly
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility)
    return () => {
      window.removeEventListener('scroll', toggleVisibility)
    }
  }, [])

  return (
    <div className="scroll-to-top">
      {isVisible && (
        <button
          type="button"
          onClick={scrollToTop}
          className="scroll-top-button"
          title="Scroll to top"
        >
          <i className="fa fa-arrow-up"></i>
        </button>
      )}
    </div>
  )
}
